<template>
<div style="padding:5px">
    <v-layout row wrap>
        <v-flex xs12>
            <v-card class="elevation-3 dash-card">
                <v-toolbar class="q-orange-bk q-text-whitesmoke elevation-1" style="height:50px;">
                    <v-toolbar-title style="padding-bottom:15px">
                        <h3>{{getString('Lista DLC')}}</h3>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-layout>
                        <v-btn class="q-orange-bk q-text-whitesmoke" @click="init">
                            <v-icon>refresh</v-icon>
                        </v-btn>
                        <v-flex xs12 lg12>
                            <v-text-field type="text" v-model="search" :label="getString('Filtra')" solo color="red lighten-3" />
                        </v-flex>
                    </v-layout>
                    <v-data-table :headers="Headers" :items="dlcs" item-key="idDlc" :rows-per-page-items="[10,25,50,100,{text:getString('Tutto'),value:-1}]" :rows-per-page-text="getString('DLC per pagina')" :no-data-text="getString('Dati non disponibili')"
                        :loading="loading" class="elevation-0">
                        <template slot="items" slot-scope="props">
                            <tr style="max-height:100px;overflow:hidden;cursor:pointer">
                                <td class="text-xs-left">{{props.item.idDlc}}</td>
                                <td class="text-xs-left">{{props.item.dlc}}</td>
                                <td class="text-xs-left">{{props.item.comment}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-text>
                  <v-flex xs12 lg3>
                    <v-text-field solo v-model="newDlc" placeholder="Univoque name" />
                    <v-text-field solo v-model="newDlcComment" placeholder="Univoque comment" />
                    <v-btn class="q-orange-bk q-text-whitesmoke" @click="addNewDlc" >
                      {{getString('Nuovo dlc')}}
                    </v-btn>
                  </v-flex>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</div>
</template>

<script>
import ajax from '../../../ajax'
import Utils from '../../../utils'
var ut = new Utils()
export default {
  name: 'AdminDlc',
  mounted: function() {
    this.init()
  },
  computed: {
    notEmpty: function() {
      return [v => !!v || this.getString('Campo richiesto')]
    },
    emailRule: function() {
      return [
        v => !!v || this.getString('Campo richiesto'),
        v => ut.ValidateEmail(v) || this.getString('Email non valida')
      ]
    },
    numRule: function() {
      return [
        v => !!v || this.getString('Campo richiesto'),
        v =>
          ut.ValidateNumber(v) ||
          this.getString('Numero non valido, torniamo a scuola per cortesia?')
      ]
    },
    locale: function() {
      return this.$store.state.currentTranslator.locale
    },
    Headers: function() {
      let result = []
      let self = this
      if (this.userapp.length > 0) {
        let temp = [
          self.getString('IdDlc:IdDlc'),
          self.getString('DLC'),
          self.getString('Commento')
        ]
        return temp
      }
      return []
    }
  },
  data: () => {
    return {
      h: null,
      newDlc: '',
      newDlcComment: '',
      active: null,
      userapp: [],
      search: null,
      loading: false,
      selectedUser: {},
      noteDialog: false,
      currNote: '',
      dlcs: [],
      stats: [
        { OS: '0', Count: 0 },
        { OS: '1', Count: 0 },
        { OS: '2', Count: 0 }
      ],
      dialogCost: 0,
      dialogDateMenu: false,
      dialogNote: '',
      dialogCheck: false,
      dialogDate:
        new Date().getFullYear() +
        '-' +
        ut.NumberWith0(new Date().getMonth() + 1) +
        '-' +
        ut.NumberWith0(1),
      newDialog: false,
      nameShopNewDialog: '',
      addressNewDialog: '',
      cityNewDialog: '',
      provNewDialog: '',
      capNewDialog: '',
      geoNewDialog: '',
      noteNewDialog: ''
    }
  },
  methods: {
    addNewDlc: function() {
      let self = this
      if(self.newDlc !== null && self.newDlc !== '')
      {
      ajax.axios
        .post(ajax.baseUrl() + '/admin/man/dlc', {
          uname : self.newDlc,
          comment: self.newDlcComment
        }, {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          self.init()
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router)
          self.$emit(
            'siteAlert',
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          )
        })
      }
    },
    init: function() {
      let self = this
      ajax.axios
        .get(ajax.baseUrl() + '/admin/man/dlc', {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          self.dlcs = response.data.data
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router)
          self.$emit(
            'siteAlert',
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          )
        })
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key)
      return page
    }
  }
}
</script>

<style>
.q-dark-bk {
  background-color: #424242 !important;
}

.q-dark-text {
  color: #f5f5f5 !important;
}

.q-light-bk {
  color: #f5f5f5 !important;
}

.q-light-text {
  color: #424242 !important;
}

.full-width {
  width: 100% !important;
}

h1,
h2,
h3 {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/AdminDlc.vue